import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';

import { EstablishmentService } from '../shared/establishment/establishment.service';
import { Establishment } from '../shared/establishment/model/establishment';
import { UsersService } from '../user-management/users/users.service';

@Injectable()
export class ShowCombinedReportsResolver implements Resolve<boolean> {
  constructor(
    private establishmentsService: EstablishmentService,
    private usersService: UsersService
  ) {}

  public resolve(): Observable<boolean> {
    // tslint:disable-next-line
    return combineLatest(
      this.establishmentsService.establishments$,
      this.usersService.allowReports(),
      (establishments: Array<Establishment>, isAllowed: boolean) => {
        return (
          isAllowed && (establishments != null && establishments.length > 1)
        );
      }
    );
  }
}
